import { useMemo } from 'react';
import type { IntlShape } from 'react-intl';

import {
  GlobalFeedbackKey,
  PersonalProductivityEntryPointId,
  useFeedbackCollector,
} from '@trello/feedback-collector';

/**
 * Generates a FeedbackCollector and display callback preconfigured for
 * the Personal Productivity global feedback JSM endpoint.
 */
export const useGlobalFeedbackCollector = (intl: IntlShape) => {
  // Memoization prevents the feedback collector from flashing while the header is rerendering
  const feedbackInputs = useMemo(() => {
    return {
      attributes: { 'project-key': GlobalFeedbackKey },
      feedbackCollectorProps: {
        feedbackTitle: intl.formatMessage({
          id: 'templates.header_feedback.feedback-modal-title-alt',
          defaultMessage: 'Share your thoughts on your Trello experience',
          description:
            'Invitation for the user to share their feedback about the new Personal Productivity features',
        }),
      },
    };
  }, [intl]);

  return useFeedbackCollector({
    entrypointId: PersonalProductivityEntryPointId,
    source: 'appHeader',
    attributes: feedbackInputs.attributes,
    feedbackCollectorProps: feedbackInputs.feedbackCollectorProps,
  });
};
